import { ActionTypes } from '../../constants/ActionTypes';
import { ISendLetterInformationReducer } from '../../interfaces/SendLetterInformation';

const sendLetterInformation: ISendLetterInformationReducer = {
  completeTransAction: false,
  letterCode: null,
  subject: null,
  letterNumber: null,
};

const sendLetter = (state = sendLetterInformation, action: any) => {
  switch (action.type) {
    case ActionTypes.SEND_LETTER:
      return {
        ...state,
        completeTransAction: false,
        letterCode: null,
        subject: null,
        letterNumber: null,
      };

    case ActionTypes.SEND_LETTER_SUCCESS: {
      const model = action.payload;
      return {
        ...state,
        completeTransAction: true,
        letterCode: model.letterCode,
        subject: model.subject,
        letterNumber: model.letterNumber,
      };
    }

    case ActionTypes.CHANGE_SEND_LETTER_STATUS: {
      const model = action.payload;
      return {
        ...state,
        completeTransAction: false,
        letterCode: null,
        subject: null,
        letterNumber: null,
      };
    }

    default:
      return state;
  }
};

export default sendLetter;
